<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>


  export default {  
    name: 'app',
    components: {},
  }
</script>

<style lang="scss">

  @import "./sass/main.scss";

  #toast-container {
      font-size: 12px !important;
  }

  #toast-container > .md-toast {
      // width: 50%;
      width: 250px;
  }
</style>
